import React from 'react';
import { theme } from 'antd';
import { EPButton } from '@/components';
import { StyledButtonDrawer } from './ContinueButtonDrawer.styles';

const { useToken } = theme;

interface ContinueButtonDrawerProps {
  visible: boolean;
  buttonText: string;
  loading: boolean;
  onClick?: () => void;
  htmlType?: 'button' | 'submit' | 'reset';
  maskClosable?: boolean;
}

const ContinueButtonDrawer: React.FC<ContinueButtonDrawerProps> = ({
  visible,
  buttonText,
  loading,
  onClick,
  htmlType = 'button',
  maskClosable = true,
}) => {
  const { token } = useToken();

  return (
    <StyledButtonDrawer
      className="continue-button-drawer continue-button-drawer-custom"
      open={visible}
      placement="bottom"
      closable={false}
      mask={false}
      maskClosable={maskClosable}
      height="auto"
      theme={{ token }}
    >
      <div className="button-container">
        <EPButton type="primary" size="large" onClick={onClick} loading={loading} htmlType={htmlType}>
          {buttonText}
        </EPButton>
      </div>
    </StyledButtonDrawer>
  );
};

export default ContinueButtonDrawer;
